import { GET_LANDS_LIST, LAND_ERROR, DELETE_LAND, CREATE_LAND, EDIT_LAND, START_LOADING, ACCESS_RIGHT_ERROR, STOP_LOADING } from "../LandActions/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false,
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_LANDS_LIST:
      return {
        ...state,
        lands_list: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case CREATE_LAND:
      return {
        ...state,
        new_land: action.payload,
        loading: false
      }
    case EDIT_LAND:
      return {
        ...state,
        edited_land: action.payload,
        loading: false
      }
    case DELETE_LAND:
      return {
        ...state,
        success: true,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case LAND_ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }
    case ACCESS_RIGHT_ERROR:
      return {
        ...state,
        access_error: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}